<template>
	<i class="symbol help left">
		<object
			tabindex="-1"
			type="image/svg+xml"
			data="/static/build/gfx/svg/symbol-warning.svg"
		/>

		<object
			class="help-hover"
			tabindex="-1"
			type="image/svg+xml"
			data="/static/build/gfx/svg/symbol-warning-hover.svg"
		/>
	</i>
</template>
